import React from 'react';

function Variables({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M14 20v-2h3c.283 0 .52-.096.712-.288A.968.968 0 0 0 18 17v-2c0-.633.183-1.208.55-1.725.367-.517.85-.883 1.45-1.1v-.35a2.977 2.977 0 0 1-1.45-1.1A2.912 2.912 0 0 1 18 9V7a.967.967 0 0 0-.288-.713A.968.968 0 0 0 17 6h-3V4h3c.833 0 1.542.292 2.125.875S20 6.167 20 7v2c0 .283.096.52.288.713.191.191.429.287.712.287h1v4h-1a.968.968 0 0 0-.712.287A.968.968 0 0 0 20 15v2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 17 20h-3Zm-7 0a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 17v-2a.968.968 0 0 0-.288-.713A.967.967 0 0 0 3 14H2v-4h1c.283 0 .52-.096.712-.287A.968.968 0 0 0 4 9V7c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 4h3v2H7a.968.968 0 0 0-.713.287A.968.968 0 0 0 6 7v2c0 .633-.183 1.208-.55 1.725-.367.517-.85.883-1.45 1.1v.35c.6.217 1.083.583 1.45 1.1.367.517.55 1.092.55 1.725v2c0 .283.096.52.287.712.192.192.43.288.713.288h3v2H7Z"
            />
        </svg>
    );
}

export default Variables;
